export enum DatePreference {
  DAY_MONTH = 'DD/MM',
  MONTH_DAY = 'MM/DD',
  NONE = 'none',
  DEFAULT = DatePreference.MONTH_DAY,
}
